import { render, staticRenderFns } from "./SingleItemContent.vue?vue&type=template&id=1b455abf&scoped=true&"
import script from "./SingleItemContent.vue?vue&type=script&lang=js&"
export * from "./SingleItemContent.vue?vue&type=script&lang=js&"
import style0 from "./SingleItemContent.vue?vue&type=style&index=0&id=1b455abf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b455abf",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImg, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BImg, BCol, BRow})
    

export default component.exports